export default __webpack_public_path__ + "static/media/s1.40e39243.png";